<template>
	<img
			v-if="kind === 'image' && !failed && src"
			:src="src"
			:alt="item.name ?? ''"
			loading="lazy"
			decoding="async"
			@error="failed = true"
	/>
	<div v-else class="media-thumb" :title="title">
		<i :class="icon"></i>
		<span v-if="extension" class="media-thumb__badge">{{ extension }}</span>
	</div>
</template>

<script setup lang="ts">
import {computed, PropType, ref, watch} from 'vue';
import {extensionOf, mediaKind, MediaPreviewItem} from "../Utils/MediaKind";

const props = defineProps({
	item: {
		type: Object as PropType<MediaPreviewItem>,
		required: true,
	},
});

// The browser may not be able to show the image (for example an AVIF in an older browser)
const failed = ref(false);

const kind = computed(() => mediaKind(props.item));
const src = computed(() => props.item.thumbnail ?? props.item.webp ?? props.item.original ?? '');
const extension = computed(() => (props.item.extension ?? extensionOf(props.item.original)).toLowerCase());

const icon = computed(() => {
	if (kind.value === 'image') {
		return 'fa-regular fa-image';
	}
	if (kind.value === 'video') {
		return 'fa-solid fa-video';
	}
	return extension.value === 'pdf' ? 'fa-solid fa-file-pdf' : 'fa-solid fa-file';
});

const title = computed(() => kind.value === 'image'
	? `Az előnézet nem jeleníthető meg${extension.value ? ' (' + extension.value.toUpperCase() + ')' : ''}`
	: (props.item.name ?? ''));

watch(src, () => {
	failed.value = false;
});
</script>
